import { AUTH } from '../constants';

export const signIn = () => ({
  type: AUTH.SIGNIN.REQUEST,
});
export const signOut = () => ({
  type: AUTH.SIGNOUT,
});
export const getAuthenticatedUser = () => ({
  type: AUTH.GET_USER,
});



// WEBPACK FOOTER //
// ./src/store/actions/auth.actions.js